<template>
  <div class="item-container">
    <template v-for="(lang, index) in TRANSLATE_LANGUAGES" :key="index">
      <button
        :class="[
          'item',
          {
            active: lang === getLanguage,
          },
        ]"
        @click="changeLanguage(lang)"
      >
        <span class="item-title">{{ lang }}</span>
      </button>
      <div v-if="index !== TRANSLATE_LANGUAGES.length - 1">
        <span class="title-divider"> | </span>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TRANSLATE_LANGUAGES } from "@/data/countriesLanguageList";
import { useStore } from "vuex";

const store = useStore();

const getLanguage = computed(() => {
  return store.getters["auth/getLanguage"];
});

const changeLanguage = (lang) => {
  store.commit("auth/SET_LANGUAGE", lang);
};
</script>

<style lang="scss" scoped>
.item-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px auto;
}

.item {
  display: flex;
  align-items: center;
  padding: 0;
  height: 40px;
  border-radius: 9px;
  background-color: transparent;
  border: 1px solid transparent;

  .item-title {
    font-size: 0.9rem;
    text-transform: uppercase;
  }

  &.active {
    .item-title {
      font-weight: 500;
      color: #7a70df;
    }
  }
}

.title-divider {
  margin: 0 8px;
  font-weight: 500;
  font-size: 17px;
}
</style>
